import { put, call } from 'redux-saga/effects';
import actions from './actions';
import ApiInstance from '../../helpers/apiInstance';
import { sendRequest } from '../../helpers/saga';
import { logger } from '../../helpers/logger';

const api = new ApiInstance('countries_settings');

function* loadCountriesSettings() {
  try {
    const result = yield call(sendRequest, api.get, {}, actions.LOAD_COUNTRIES_SETTINGS_ERROR);

    if (result.status === 200 && result?.data) {
      // Extract countries_settings from response if it exists, otherwise use data directly
      const countriesSettings = result.data.countries_settings || result.data;
      yield put(actions.loadCountriesSettingsSuccess(countriesSettings));
    }
  } catch (error) {
    logger.error(error);
  }
}

export { loadCountriesSettings };
